/* eslint-disable react/jsx-props-no-spreading */
import React, { FunctionComponent } from 'react';
import { Link as ChromaLink } from '@iag-packages/chroma-react/lib/components';
import styled from 'styled-components';
import THEME from 'theme';

interface LinkProps {
  inline?: boolean;
  [key: string]: unknown;
}

const LinkWrapper = styled.div<LinkProps>`
  display: ${({ inline }) => (inline ? 'inline' : 'block')};

  .c-link {
    color: ${THEME.LINK.DEFAULT};
    font-weight: 300;
    margin: 0.6em 0;

    &:active {
      color: ${THEME.LINK.DEFAULT};
      background-color: transparent !important;
    }
  }
`;

export const Link: FunctionComponent<LinkProps> = ({ inline, ...props }) => (
  <LinkWrapper inline={inline}>
    <ChromaLink {...props} />
  </LinkWrapper>
);

export default Link;
